/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyDiemsRatesCountry
 */
export interface ReadOnlyDiemsRatesCountry {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    iso2: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    iso3: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    timeZone: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    vatRate: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRatesCountry
     */
    tachoAlpha?: string;
}

export function ReadOnlyDiemsRatesCountryFromJSON(json: any): ReadOnlyDiemsRatesCountry {
    return ReadOnlyDiemsRatesCountryFromJSONTyped(json, false);
}

export function ReadOnlyDiemsRatesCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyDiemsRatesCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'iso2': json['iso2'],
        'iso3': json['iso3'],
        'timeZone': json['time_zone'],
        'currency': json['currency'],
        'vatRate': json['vat_rate'],
        'tachoAlpha': !exists(json, 'tacho_alpha') ? undefined : json['tacho_alpha'],
    };
}

export function ReadOnlyDiemsRatesCountryToJSON(value?: ReadOnlyDiemsRatesCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'iso2': value.iso2,
        'iso3': value.iso3,
        'time_zone': value.timeZone,
        'currency': value.currency,
        'vat_rate': value.vatRate,
        'tacho_alpha': value.tachoAlpha,
    };
}


